// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"4a302e95","990":"64c60ef0"}[chunkId] + ".chunk.css";
};